import * as React from 'react';
// PLOP: Imports
const Timeline = React.lazy(() => import(/* webpackChunkName: "Timeline" */ '@/components/organisms/Timeline'));
const TimelineHero = React.lazy(() => import(/* webpackChunkName: "TimelineHero" */ '@/components/organisms/TimelineHero'));
const TwoColumnRichText = React.lazy(() => import(/* webpackChunkName: "TwoColumnRichText" */ '@/components/organisms/TwoColumnRichText'));
const BookingEntryPoint = React.lazy(() => import(/* webpackChunkName: "BookingEntryPoint" */ '@/components/organisms/BookingEntryPoint'));
const JobListing = React.lazy(() => import(/* webpackChunkName: "JobListing" */ '@/components/organisms/JobListing'));
const ArticleHero = React.lazy(() => import(/* webpackChunkName: "ArticleHero" */ '@/components/organisms/ArticleHero'));
const ArticleCardListing = React.lazy(() => import(/* webpackChunkName: "ArticleCardListing" */ '@/components/organisms/ArticleCardListing'));
const RichTextGrid = React.lazy(() => import(/* webpackChunkName: "RichTextGrid" */ '@/components/organisms/RichTextGrid'));
const HomepageHero = React.lazy(() => import(/* webpackChunkName: "HomepageHero" */ '@/components/organisms/HomepageHero'));
const HotelContactListing = React.lazy(() => import(/* webpackChunkName: "HotelContactListing" */ '@/components/organisms/HotelContactListing'));
const PromotedArticles = React.lazy(() => import(/* webpackChunkName: "PromotedArticles" */ '@/components/organisms/PromotedArticles'));
const Header = React.lazy(() => import(/* webpackChunkName: "Header" */ '@/components/organisms/Header'));
const ThirdLevelHero = React.lazy(() => import(/* webpackChunkName: "ThirdLevelHero" */ '@/components/organisms/ThirdLevelHero'));
const Footer = React.lazy(() => import(/* webpackChunkName: "Footer" */ '@/components/organisms/Footer'));
const FeatureSplitFixScroll = React.lazy(() => import(/* webpackChunkName: "FeatureSplitFixScroll" */ '@/components/organisms/FeatureSplitFixScroll'));
const MediaListing = React.lazy(() => import(/* webpackChunkName: "MediaListing" */ '@/components/organisms/MediaListing'));
const InPageNavigation = React.lazy(() => import(/* webpackChunkName: "InPageNavigation" */ '@/components/organisms/InPageNavigation'));
const TileBlock = React.lazy(() => import(/* webpackChunkName: "TileBlock" */ '@/components/organisms/TileBlock'));
const CtaBlock = React.lazy(() => import(/* webpackChunkName: "CtaBlock" */ '@/components/organisms/CtaBlock'));
const LocomotiveFeatureContent = React.lazy(() => import(/* webpackChunkName: "LocomotiveFeatureContent" */ '@/components/organisms/LocomotiveFeatureContent'));
const AnchorNavigation = React.lazy(() => import(/* webpackChunkName: "AnchorNavigation" */ '@/components/organisms/AnchorNavigation'));
const AnchorSplitScroll = React.lazy(() => import(/* webpackChunkName: "AnchorSplitScroll" */ '@/components/organisms/AnchorSplitScroll'));
const FullWidthMedia = React.lazy(() => import(/* webpackChunkName: "FullWidthMedia" */ '@/components/organisms/FullWidthMedia'));
const ArticleGroupListing = React.lazy(() => import(/* webpackChunkName: "ArticleGroupListing" */ '@/components/organisms/ArticleGroupListing'));
const SplitContent = React.lazy(() => import(/* webpackChunkName: "SplitContent" */ '@/components/organisms/SplitContent'));
const CardList = React.lazy(() => import(/* webpackChunkName: "CardList" */ '@/components/organisms/CardList'));
const RichText = React.lazy(() => import(/* webpackChunkName: "RichText" */ '@/components/organisms/RichText'));
const FeatureText = React.lazy(() => import(/* webpackChunkName: "FeatureText" */ '@/components/organisms/FeatureText'));
const MediaCardList = React.lazy(() => import(/* webpackChunkName: "MediaCardList" */ '@/components/organisms/MediaCardList'));
const SplitFixScroll = React.lazy(() => import(/* webpackChunkName: "SplitFixScroll" */ '@/components/organisms/SplitFixScroll'));
const HeroCardList = React.lazy(() => import(/* webpackChunkName: "HeroCardList" */ '@/components/organisms/HeroCardList'));
const SplitContentHorizontal = React.lazy(() => import(/* webpackChunkName: "SplitContentHorizontal" */ '@/components/organisms/SplitContentHorizontal'));
const ApartmentListing = React.lazy(() => import(/* webpackChunkName: "ApartmentListing" */ '@/components/organisms/ApartmentListing'));
const ResidenceListing = React.lazy(() => import(/* webpackChunkName: "ResidenceListing" */ '@/components/organisms/ResidenceListing'));
const SplitParallax = React.lazy(() => import(/* webpackChunkName: "SplitParallax" */ '@/components/organisms/SplitParallax'));
const Quotes = React.lazy(() => import(/* webpackChunkName: "Quotes" */ '@/components/organisms/Quotes'));
const BrandedFeature = React.lazy(() => import(/* webpackChunkName: "BrandedFeature" */ '@/components/organisms/BrandedFeature'));
const SecondaryHero = React.lazy(() => import(/* webpackChunkName: "SecondaryHero" */ '@/components/organisms/SecondaryHero'));
const Map = React.lazy(() => import(/* webpackChunkName: "Map" */ '@/components/organisms/Map'));
const Sitemap = React.lazy(() => import(/* webpackChunkName: "Sitemap" */ '@/components/organisms/Sitemap'));
export default {
    // PLOP: Exports
    AnchorNavigation,
    AnchorSplitScroll,
    ApartmentListing,
    ArticleCardListing,
    ArticleGroupListing,
    ArticleHero,
    BookingEntryPoint,
    BrandedFeature,
    CardList,
    CTABlock: CtaBlock, // dotnet usage isn't following pascal case rules
    FeatureSplitFixScroll,
    FeatureText,
    Footer,
    FullWidthMedia,
    Header,
    HeroCardList,
    HomepageHero,
    HotelContactListing,
    InPageNavigation,
    JobListing,
    LocomotiveFeatureContent,
    Map,
    MediaCardList,
    MediaListing,
    PromotedArticles,
    Quotes,
    ResidenceListing,
    RichText,
    RichTextGrid,
    SecondaryHero,
    SplitContent,
    SplitContentHorizontal,
    SplitFixScroll,
    SplitParallax,
    ThirdLevelHero,
    TileBlock,
    Timeline,
    TimelineHero,
    TwoColumnRichText,
    Sitemap,
};
